<template>
  <div :class="['Single', page.template]">
    <div v-if="!hideSidebar" class="sidebar pill-hover">
      <LazyImage
        :image="thumbnail"
        :size="'large'"
        :circle="page.template === 'dj'"
      ></LazyImage>
    </div>
    <div class="content">
      <div class="heading">
        <div v-if="page.audio" class="heading-button hover-icon">
          <IconPlayBroadcast
            class="large"
            v-if="page.audio"
            v-bind="page.audio"
            :page-url="page.url"
            :large="true"
          >
          </IconPlayBroadcast>
        </div>
        <div class="heading-title a-hover">
          <p
            v-if="isGuestSession"
            v-html="page.guest_performer"
            class="artist-name"
          ></p>
          <!-- This next line is causing problems because most archives dont have a performer field -->
          <!-- Must link to selected artist taxonomy as fallback -->

          <ul
            v-if="isValidArchive && isValidArchive.length"
            class="bullet-list tags"
          >
            <li v-for="artist in isValidArchive" :key="artist.id">
              <router-link
                v-html="artist"
                class="artist-name"
                :to="'/djs/' + slugifyArtistName(artist)"
              ></router-link>
            </li>
          </ul>
          <h2>
            <!-- make this if statement not cursed -->
            <!-- var re = new RegExp((\W\d\d\.\d\d\.\d\d\W)); -->
            <div
              v-if="
                page.template === 'broadcast' &&
                page.show &&
                !page.broadcast_alt_name
              "
              :class="{ underline: underline }"
              v-html="page.show['post_title']"
            ></div>
            <div
              v-else-if="
                isValidArchive &&
                isGuestSession &&
                page.template === 'broadcast' &&
                page.guest_session_alt_name
              "
              v-html="page.guest_session_alt_name"
            ></div>
            <div
              v-else-if="
                isValidArchive &&
                isGuestSession &&
                page.template === 'broadcast' &&
                !page.guest_session_alt_name
              "
            >
              guest session
            </div>
            <div
              v-else-if="
                isValidArchive &&
                page.show &&
                page.template === 'broadcast' &&
                page.broadcast_alt_name
              "
              v-html="page.broadcast_alt_name"
            ></div>
            <div
              v-else-if="
                isValidArchive &&
                hasDateInTitle &&
                page.show === false &&
                !page.guest_session_alt_name &&
                hasShows === 0
              "
              v-html="page.title.substring(0, page.title.length - 10)"
            ></div>
            <div v-if="page.template === 'show'" v-html="page.title"></div>
            <div v-if="isSchedule" v-html="page.title"></div>
            <div v-if="page.djs && page.djs.length">
              w/
              <router-link
                v-for="entry in page.djs"
                :to="entry.url"
                :key="entry.url"
                class="comma"
                >{{ entry.title }}</router-link
              >
            </div>
            <!-- <div
              v-if="page.template === 'broadcast' && isGuestSession"
            >guest session</div> -->
            <div v-if="page.template === 'dj'" v-html="page.title"></div>
            <div
              v-if="page.schedule"
              v-html="page.schedule"
              class="showSchedule"
            ></div>
          </h2>
          <div v-if="hasShows && page.template === 'dj'" class="shows">
            Shows:
            <router-link
              v-for="entry in page.shows"
              :to="entry.url"
              :key="entry.url"
              class="comma"
              >{{ entry.title }}</router-link
            >
          </div>
          <div v-if="isSchedule" class="date">
            <div>{{ page.formatted.date }}</div>
            <div>{{ page.formatted.time }}</div>
          </div>
          <div v-if="page.external_link" class="archive-link">
            <vue-link :to="page.external_link" class="pill"
              >Listen Now</vue-link
            >
          </div>
          <p v-if="page.broadcast_date" class="date-text">
            {{
              page.broadcast_date.slice(4, 6) +
              "." +
              page.broadcast_date.slice(6, 8) +
              "." +
              page.broadcast_date.slice(2, 4)
            }}
          </p>
          <ul
            v-if="
              page.tags &&
              page.tags.length &&
              (page.template === 'show' || page.template === 'broadcast')
            "
            class="bullet-list tags"
          >
            <li v-for="tag in page.tags" :key="tag.url">
              <router-link
                :to="tag.url"
                v-if="tag.url"
                v-html="tag.name"
              ></router-link>
              <span v-else v-html="tag.name"></span>
            </li>
          </ul>
        </div>
      </div>
      <div class="image mobile">
        <LazyImage
          v-if="thumbnail"
          :image="thumbnail"
          :size="'large'"
          :circle="page.template === 'dj'"
        ></LazyImage>
      </div>
      <div class="copy" v-html="processedContent"></div>
      <div class="buttons">
        <a
          v-for="(link, i) in page.links"
          :href="link.url"
          class="pill"
          :key="i"
          >{{ link.text === "Download" ? "Player" : link.text }}
        </a>
      </div>
      <div v-if="qpages.length" class="pill solid" data-scroll-target>
        <span v-if="page.template === 'dj'"
          >Broadcasts featuring {{ page.title }}</span
        >
        <span v-else-if="page.template === 'show'"
          >Episodes of {{ page.title }}</span
        >
        <span v-else>Related Broadcasts</span>
      </div>
      <div v-if="qpages.length" class="grid-auto-sm">
        <ArchiveThumb
          v-for="item in qpages"
          :page="item"
          :key="item.url"
          :circle="true"
          class="center"
        ></ArchiveThumb>
      </div>
      <Pagination
        v-if="qpage !== undefined && qpage.numpages > 1"
        :count="qpage.numpages"
      ></Pagination>
      <BoxDonate></BoxDonate>
    </div>
  </div>
</template>

<script>
import slugify from "@sindresorhus/slugify";
import { mixin } from "@/lib/content-state";
import IconPlayBroadcast from "@/components/IconPlayBroadcast";
import ArchiveThumb from "@/components/ArchiveThumb";
import Pagination from "@/components/Pagination";
import BoxDonate from "@/components/BoxDonate";
import LazyImage from "@/components/Image";
import VueLink from "@/components/VueLink.js";
import { processImageWidths } from "@/utils/imageProcessing";

export default {
  name: "Single",
  components: {
    BoxDonate,
    LazyImage,
    ArchiveThumb,
    Pagination,
    IconPlayBroadcast,
    VueLink,
  },
  mixins: [mixin],
  data() {
    return {
      underline: false,
    };
  },
  methods: {
    slugifyArtistName(name) {
      return slugify(name);
    },
  },
  computed: {
    hasShows() {
      return this.page.shows && this.page.shows.length;
    },
    hideSidebar() {
      return !this.thumbnail && this.page.template === "default";
    },
    isSchedule() {
      return this.$route.name === "schedule";
    },
    isGuestSession() {
      return this.page.guest_session;
    },
    isValidArchive() {
      return this.page.artists;
    },
    hasDateInTitle() {
      var re = new RegExp(/(\W\d\d\.\d\d\.\d\d\W)/);
      if (re.test(this.page.title)) {
        return true;
      } else return false;
    },
    processedContent() {
      return processImageWidths(this.page.content);
    },
    sidebarContent() {
      const processedSubcontent = processImageWidths(this.page.subcontent);
      return `<div class="copy pill-hover">${processedSubcontent}</div>`;
    },
  },
};
</script>

<style scoped>
.Single {
  display: flex;
  justify-content: flex-end;
  padding: 2rem 0;
  width: 82%;
  margin: 0 auto;
}

.stuck {
  position: fixed;
  left: 0;
}

/**
 * Content
 */

.content {
  width: 66.6%;
  padding-left: calc(5% + 1rem);
  padding-right: 5%;
}

.content > * + * {
  margin-top: 4rem;
}

.content > .copy,
.content > .grid-auto-sm {
  margin-top: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(28rem, 1fr));
}

.content > .pill {
  width: 100%;
}

/**
 * Heading
 */

.heading {
  text-align: center;
}

.broadcast .heading {
  display: flex;
  text-align: left;
}

.heading-title {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.heading-button {
  width: 14%;
  max-width: 10rem;
  margin-right: 2rem;
  padding-top: 1rem;
}

h2 {
  font: var(--large);
  margin-bottom: 0.6rem;
}

.shows {
  text-align: center;
}

.archive-link {
  padding-top: 1.5rem;
}

.date-text {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  margin-bottom: 0.6rem;
}

.artist-name {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  margin-bottom: 0.4rem;
}

.showSchedule {
  font: var(--medium_mono);
  letter-spacing: 0.03em;
  padding-top: 1rem;
}

/**
 * Copy
 */

.copy {
  font: var(--smallish);
}

.copy >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
  display: block;
  margin: 4rem auto;
}

.copy >>> .tracklist em {
  display: inline-block;
  margin-bottom: 1.5rem;
  margin-top: 0.75rem;
  font-style: italic;
  /* font-weight: 400; */
}

.copy >>> .tracklist p {
  margin-bottom: 1.5rem;
  /* font-weight: 600; */
}

.copy >>> .tracklist br {
  content: "";
  display: block;
  margin-bottom: 0.75rem;
}

.copy >>> .tracklist a {
  color: #4682b4;
}

/* .copy >>> .tracklist span {
  font-weight: 200;
} */

/**
 * Sidebar
 */

/*.sidebar {
  width: 38%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-right: 1rem;
}*/

.sidebar {
  position: sticky;
  top: 100px;
  align-self: flex-start;
  padding-right: 1rem;
  width: 50%;
}

.sidebar figure {
  width: 100%;
  text-align: center;
}

.sidebar figure:not(.circle) >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
}

.sidebar .buttons {
  margin: 1rem;
}

.sidebar .buttons a,
.sidebar .buttons button {
  margin: 1rem;
  font: var(--medium);
}

/**
 * Mobile
 */

.mobile {
  display: none;
}

.mobile {
  margin: 2rem auto 0;
}

.mobile >>> figure {
  text-align: center;
}

.mobile >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
}

.copy .logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1rem 0;
}

@media (max-width: 1000px) {
  .Single {
    grid-template-columns: 1fr;
    padding-top: 0;
  }

  .sidebar {
    display: none;
  }

  .mobile {
    display: block;
  }

  .showSchedule {
    font: var(--small_mono);
    letter-spacing: 0.03em;
    padding-top: 1rem;
  }

  .heading-title {
    padding-top: 2rem;
  }

  .content {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  h2 {
    margin-bottom: 1rem;
  }
}
</style>
